import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { RippleModule } from 'primeng/ripple';
import { CheckboxModule } from 'primeng/checkbox';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { MsalService } from '@azure/msal-angular';
import { PopupRequest, RedirectRequest } from '@azure/msal-browser';
 
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [CheckboxModule, RippleModule, ButtonModule, InputTextModule],
})
export class SignupComponent {
  private msalService = inject(MsalService);

  constructor() {}

  signUp() {
    const signUpFlowRequest: RedirectRequest | PopupRequest = {
      authority: environment.b2cPolicies.authorities.signUp.authority,
      scopes: [],
    };
    this.msalService.initialize().subscribe(() => {
      this.msalService.instance.loginRedirect(signUpFlowRequest);
    });
    //this.msalService.loginRedirect(signUpFlowRequest);
  }
}
